import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import type { SelectProps } from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const toHumanReadableDate = (date: number) => `dia ${date < 10 ? '0' : ''}${date}`;

const dueDate = new Array(28)
  .fill('')
  .map((_, index) => ({ value: index + 1, label: toHumanReadableDate(index + 1) }));

const SelectDueDate = (props: SelectProps) => (
  <Select
    {...props}
    variant="standard"
    renderValue={(selected: any) => (
      <Chip
        label={toHumanReadableDate(selected)}
        sx={{
          backgroundColor: '#f5f5f5',
          border: '1px solid #e0e0e0',
          height: '28px',
          mt: '-4px',
          '& .MuiChip-label': {
            fontSize: '0.875rem',
            padding: '0 8px',
          },
        }}
      />
    )}
    MenuProps={MenuProps}

  >
    {dueDate.map((day) => (
      <MenuItem key={day.value} value={day.value}>
        {day.label}
      </MenuItem>
    ))}
  </Select>
);

export default SelectDueDate;
